import React from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { AuthContext } from "../../auth/authContext";
import {
  reporteCobranzaRangoFecha,
  reporteCuboComisionesContratos,
  reporteCuboComisionesOrdenes,
  reporteNomina,
  reporteNominaComisionesOrdenesServicioPorUsuarioAPII,
  reporteNominaComisionesOrdenServicioAPII,
  reporteNominaComisionesPrevisionAPI,
  reporteNominaComisionesPrevisionPorUsuarioAPI,
  reporteNominaSueldos,
  reporteResumenSerie,
} from "../../API/ApiReportes";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LoadingComponent } from "../../Components/LoadingComponent/LoadingComponent";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";
import { SinPermisoComponent } from "../../Components/SinPermisoComponent/SinPermisoComponent";
import { BuscadorDeOrdenesDeServicioHookComponent } from "../../Components/BuscadorDeOrdenesDeServicioHookComponent/BuscadorDeOrdenesDeServicioHookComponent";
import { getAllEmpleadosParaSelect } from "../../API/ApiEmpleados";
import { BuscadorDeContratosParaPagoComponent } from "../../Components/BuscadorDeContratosParaPagoComponent/BuscadorDeContratosParaPagoComponent";
import { BuscadorDeContratosParaReporteComponent } from "../../Components/BuscadorDeContratosParaReporteComponent/BuscadorDeContratosParaReporteComponent";
import { toast } from "react-toastify";
import imageVitanova from "../../Images/LogotipoNegro.png";

import ReactToPrint from "react-to-print";
import { ButtonDownloadToXlsComponent } from "../../Components/ButtonDownloadToXlsComponent/ButtonDownloadToXlsComponent";
import { ImprimirPdfComponentOrdenesServicio } from "./../../Components/ImprimirPdfComponentOrdenesServicio/ImprimirPdfComponentOrdenesServicio";
import { ImprimirPdfComponentOrdenesServicioPersona } from "./../../Components/ImprimirPdfComponentOrdenesServicioPersona/ImprimirPdfComponentOrdenesServicioPersona";

const guidVista = "ef433e95-e3b0-4caa-a533-3b599add112e";

const ListToPrintComponent = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  const [totalSalarios, setTotalSalarios] = React.useState(0.0);

  React.useEffect(() => {
    var totalSalarios = 0.0;

    for (const salario of props.value) {
      totalSalarios = totalSalarios + parseFloat(salario.totalComision);
    }

    setTotalSalarios(totalSalarios);
  }, [props]);

  return (
    <div className="print-source " ref={ref}>
      <img
        alt="Vitanova Logo"
        className="mt-3"
        src={imageVitanova}
        width="150"
      />
      <br />

      <h3 className="mt-3">
        Reporte de Comisiones de venta (Órdenes de servicio)
      </h3>
      <h6>
        de: {props.fechaInicio} a: {props.fechaFin}
      </h6>
      {props.value.map((empleado, index) => (
        <div className="container-fluid" key={index}>
          <div className="row">
            <div className="col-6">{empleado.nombreEmpleado}</div>
            <div className="col-6">
              {"$ "}{" "}
              {parseFloat(empleado.totalComision)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
          </div>
        </div>
      ))}
      <div className="container small">
        <div className="row">
          <div className="col-6">
            <strong>Total:</strong>
          </div>
          <div className="col-6">
            {"$ "}{" "}
            {parseFloat(totalSalarios)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>
        </div>
      </div>
      <br />
    </div>
  );
});

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  var total = 0;

  return (
    <div className="print-source " ref={ref}>
      <img alt="Vitanova Logo" src={imageVitanova} width="150" />
      <br />
      <br />
      <h5>Recibo de Comisiones Órdenes de Servicio</h5>
      <br />
      <br />
      <strong> Nombre </strong> {props.value.nombreEmpleado}
      <br />
      <strong>
        {" "}
        De: {CambiarFormatoFechaHelper(props.fechaInicio)} a:{" "}
        {CambiarFormatoFechaHelper(props.fechaFin)}{" "}
      </strong>
      <br />
      <br />
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Comisión</th>
            <th scope="col">
              {"$ "}{" "}
              {parseFloat(props.value.totalComision)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </th>
          </tr>
        </thead>
      </table>
      <br />
      <br />
      <div className="text-center">
        _____________________________________________________________
        <br />
        Firma
      </div>
      <br />
      <br />
      <br />
      <small style={{ fontSize: "10px" }}>Impreso por: {user.username}</small>
    </div>
  );
});

const ComponentToPrintWrapper = (props) => {
  const componentRef = React.useRef();

  return (
    <>
      <tr>
        <td>{props.item.nombreEmpleado}</td>
        <td>
          {"$ "}
          {props.item.totalComision}
        </td>
        <td className="d-none">
          {" "}
          <ReactToPrint
            trigger={() => (
              <button type="primary" className="btn btn-sm btn-success">
                Imprimir Recibo
              </button>
            )}
            content={() => componentRef.current}
          />
          <ComponentToPrint
            ref={componentRef}
            value={props.item}
            fechaInicio={props.fechaInicio}
            fechaFin={props.fechaFin}
          />
        </td>
      </tr>
    </>
  );
};

export const ReporteDeNominaComisioneOrdenServicioScreenComponent = () => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [reporteSerie, setReporteSerie] = React.useState("");
  const [reporteFechaInicialUno, setReporteFechaInicialUno] =
    React.useState("");
  const [reporteFechaFinUno, setReporteFechaFinUno] = React.useState("");
  const [reporteFechaInicialDos, setReporteFechaInicialDos] =
    React.useState("");
  const [reporteFechaFinDos, setReporteFechaFinDos] = React.useState("");
  const [numeroOrdenServicio, setNumeroOrdenServicio] = React.useState("");
  const [finalDataUno, setFinalDataUno] = React.useState([]);
  const [finalDataDos, setFinalDataDos] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [checkPersmissions, setCheckPermissions] = React.useState([]);
  const [permisoParaVisualizar, setPermisoParaVisualizar] =
    React.useState(false);
  const [permisoReporte, setPermisoReporte] = React.useState(false);
  const [idempleadoFound, setIdempleadoFound] = React.useState("");
  const [granTotalComisionMostrar, setGranTotalComisionMostrar] =
    React.useState(0.0);

  const [granTotalTotalMostrarUno, setGranTotalTotalMostrarUno] =
    React.useState(0.0);
  const [granTotalTotalMostrar, setGranTotalTotalMostrar] = React.useState(0.0);

  const [listadoEmpleados, setListadoEmpleados] = React.useState([]);

  const componentRefListado = React.useRef();

  React.useEffect(() => {
    let ready = false;

    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == "17227260-b09a-499a-831b-42ad3d183a41" &&
              permiso.allowed == 1
            ) {
              setPermisoParaVisualizar(true);
            }
            if (
              permiso.guidFuncion == "24e73706-34ab-442f-9cbe-d8bcdc851895" &&
              permiso.allowed == 1
            ) {
              setPermisoReporte(true);
            }
          }
        }
      }
    );

    let listo = false;

    return () => {
      listo = true;
    };

    return () => {
      ready = true;
    };
  }, []);

  const [granTotalFinalComisionesDos, setGranTotalFinalComisionesDos] =
    React.useState(0.0);
  const [granTotalFinalPagadoDos, setGranTotalFinalPagadoDos] =
    React.useState(0.0);
  const [granTotalFinalPorPagarDos, setGranTotalFinalPorPagarDos] =
    React.useState(0.0);

  const [nombreEmpleadoSeleccionado, setNombreEmpleadoSeleccionado] =
    React.useState("");

  React.useEffect(() => {
    let listo = false;

    let granTotalComision = 0.0;
    let granTotaltotal = 0.0;

    for (const serie of finalDataUno) {
      granTotaltotal = granTotaltotal + parseFloat(serie.totalComision);
    }
    setGranTotalTotalMostrarUno(granTotaltotal);

    return () => {
      listo = true;
    };
  }, [finalDataUno]);

  React.useEffect(() => {
    let listo = false;

    let granTotalComisionDos = 0.0;

    for (const serie of finalDataDos) {
      granTotalComisionDos =
        granTotalComisionDos + parseFloat(serie.montoComision);
    }

    setGranTotalFinalComisionesDos(granTotalComisionDos);

    return () => {
      listo = true;
    };
  }, [finalDataDos]);

  React.useEffect(() => {
    setFinalDataDos([]);
    setLoading(true);
    reporteNominaComisionesOrdenesServicioPorUsuarioAPII(user, {
      fechaInicial: reporteFechaInicialDos,
      fechaFin: reporteFechaFinDos,
      idempleado: idempleadoFound,
    }).then((resultado) => {
      setFinalDataDos([]);
      if (resultado.status == 200) {
        setFinalDataDos(resultado.data);
        setLoading(false);
      }
      setLoading(false);
    });
  }, [idempleadoFound]);

  React.useEffect(() => {
    let ready = false;

    getAllEmpleadosParaSelect(user).then((resultado) => {
      if (resultado.status == 200) {
        setListadoEmpleados(resultado.data);
      } else {
        setListadoEmpleados([]);
      }
    });

    return () => {
      ready = true;
    };
  }, []);

  return (
    <>
      {permisoParaVisualizar == true && permisoReporte == true ? (
        <>
          <div className="container-fluid mt-4 px-2">
            <div className="row row-cols-1">
              <ul
                className="nav nav-pills mb-3 d-print-none"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    General
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Por Empleado
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="container-fluid mb-3 mt-2 d-print-none">
                    <div className="row row-cols-md-3 d-flex align-items-center">
                      <div className="col mb-2">
                        <TextField
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          id="outlined-basic"
                          label="Fecha Inicio"
                          type="date"
                          variant="standard"
                          value={reporteFechaInicialUno}
                          onChange={(e) => {
                            setReporteFechaInicialUno(e.target.value);
                          }}
                        />
                      </div>
                      <div className="col mb-2">
                        <TextField
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          id="outlined-basic"
                          label="Fecha Fin"
                          type="date"
                          variant="standard"
                          value={reporteFechaFinUno}
                          onChange={(e) => {
                            setReporteFechaFinUno(e.target.value);
                          }}
                        />
                      </div>

                      <div className="col mb-2 d-print-none">
                        <button
                          className="btn btn-sm btn-success w-100"
                          onClick={() => {
                            setLoading(true);
                            reporteNominaComisionesOrdenServicioAPII(user, {
                              fechaInicial: reporteFechaInicialUno,
                              fechaFin: reporteFechaFinUno,
                            }).then((resultado) => {
                              if (resultado.status == 200) {
                                setFinalDataUno(resultado.data);
                                setLoading(false);
                              }
                            });
                          }}
                        >
                          {" "}
                          Buscar{" "}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row row-cols-md-1">
                      <div className="col" style={{ textAlign: "right" }}>
                        <ButtonDownloadToXlsComponent
                          data={finalDataUno}
                          fileName="Reporte Nómina - Comisiones Ordenes de Servicio General"
                        />

                        <ImprimirPdfComponentOrdenesServicio
                          data={finalDataUno}
                          fechaInicio={reporteFechaInicialUno}
                          fechaFin={reporteFechaFinUno}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid d-none">
                    <div className="row">
                      <div className="col-12">
                        <ReactToPrint
                          trigger={() => (
                            <button className="btn btn-sm btn-info my-3">
                              Imprimir Reporte General
                            </button>
                          )}
                          content={() => componentRefListado.current}
                        />
                        <ListToPrintComponent
                          ref={componentRefListado}
                          value={finalDataUno}
                          fechaInicio={reporteFechaInicialUno}
                          fechaFin={reporteFechaFinUno}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <table className="table align-middle text-center">
                          <thead>
                            <tr>
                              <th scope="col">Nombre</th>
                              <th scope="col">Comisión</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>Total: </th>
                              <th>
                                {"$ "}{" "}
                                {parseFloat(granTotalTotalMostrarUno)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </th>
                              <th> </th>
                            </tr>

                            {finalDataUno.map((empleado, index) => (
                              <React.Fragment>
                                <ComponentToPrintWrapper
                                  key={index}
                                  item={empleado}
                                  fechaInicio={reporteFechaInicialUno}
                                  fechaFin={reporteFechaFinUno}
                                />
                              </React.Fragment>
                            ))}

                            <tr>
                              <th>Total: </th>
                              <th>
                                {"$ "}{" "}
                                {parseFloat(granTotalTotalMostrarUno)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </th>
                              <th> </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <div className="container-fluid mb-3 mt-2 d-print-none">
                    <div className="row row-cols-md-4 d-flex align-items-center">
                      <div className="col mb-2">
                        <TextField
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          id="outlined-basic"
                          label="Fecha Inicio"
                          type="date"
                          variant="standard"
                          value={reporteFechaInicialDos}
                          onChange={(e) => {
                            setReporteFechaInicialDos(e.target.value);
                          }}
                        />
                      </div>
                      <div className="col mb-2">
                        <TextField
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          id="outlined-basic"
                          label="Fecha Fin"
                          type="date"
                          variant="standard"
                          value={reporteFechaFinDos}
                          onChange={(e) => {
                            setReporteFechaFinDos(e.target.value);
                          }}
                        />
                      </div>

                      <div className="col mb-2">
                        <FormControl fullWidth>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                            shrink
                          >
                            Empleado
                          </InputLabel>
                          <NativeSelect
                            shrink
                            value={idempleadoFound}
                            onChange={(e) => {
                              setIdempleadoFound(e.target.value);
                              setNombreEmpleadoSeleccionado(
                                e.target.options[e.target.selectedIndex].text
                              );
                              if (typeof myVariable === "undefined") {
                                //myVariable is undefined
                              } else {
                                setNombreEmpleadoSeleccionado(
                                  e.target.options[e.target.selectedIndex].text
                                );
                              }
                            }}
                            inputProps={{
                              name: "age",
                              id: "uncontrolled-native",
                            }}
                          >
                            <option value={""}>Todos</option>
                            {listadoEmpleados.map((empleado) => (
                              <option key={empleado.id} value={empleado.id}>
                                {empleado.nombreEmpleado}
                              </option>
                            ))}
                          </NativeSelect>
                        </FormControl>
                      </div>
                      <div className="col mb-2 d-print-none">
                        <button
                          className="btn btn-sm btn-success w-100"
                          onClick={() => {
                            setLoading(true);
                            reporteNominaComisionesOrdenesServicioPorUsuarioAPII(
                              user,
                              {
                                fechaInicial: reporteFechaInicialDos,
                                fechaFin: reporteFechaFinDos,
                                idempleado: idempleadoFound,
                              }
                            ).then((resultado) => {
                              setFinalDataDos([]);
                              if (resultado.status == 200) {
                                setFinalDataDos(resultado.data);
                                setLoading(false);
                              }
                              setLoading(false);
                            });
                          }}
                        >
                          {" "}
                          Buscar{" "}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row row-cols-md-1">
                      <div className="col" style={{ textAlign: "right" }}>
                        <ButtonDownloadToXlsComponent
                          data={finalDataDos}
                          fileName="Reporte Nómina - Comisiones Ordenes de Servicio General"
                        />
                        <ImprimirPdfComponentOrdenesServicioPersona
                          data={finalDataDos}
                          fechaInicio={reporteFechaInicialDos}
                          fechaFin={reporteFechaFinDos}
                          nombreEmpleadoSeleccionado={
                            nombreEmpleadoSeleccionado
                          }
                          totalComisiones={parseFloat(
                            granTotalFinalComisionesDos
                          )
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <img
                          alt="Vitanova Logo"
                          src={imageVitanova}
                          width="150"
                          className="d-none d-print-block"
                        />
                        <br />
                        Comisiones órdenes de servicio del:{" "}
                        {CambiarFormatoFechaHelper(
                          reporteFechaInicialDos
                        )} al: {CambiarFormatoFechaHelper(reporteFechaFinDos)}
                        <br />
                        Nombre: {nombreEmpleadoSeleccionado}
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <table className="table align-middle">
                          <thead>
                            <tr>
                              <th scope="col">Fecha</th>
                              <th scope="col">Orden Servicio</th>

                              <th scope="col">Servicio</th>
                              <th scope="col">Comisión</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>Total: </th>
                              <td></td>
                              <td></td>

                              <th>
                                {"$ "}
                                {parseFloat(granTotalFinalComisionesDos)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </th>
                            </tr>
                            {finalDataDos.map((comision, index) => (
                              <tr key={index}>
                                <th scope="row">
                                  {CambiarFormatoFechaHelper(comision.fecha)}
                                </th>
                                <td>{comision.folio}</td>
                                <td>{comision.observaciones}</td>
                                <td>
                                  {"$ "}
                                  {parseFloat(comision.montoComision)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                </td>
                              </tr>
                            ))}

                            <tr>
                              <th>Total: </th>
                              <td></td>
                              <td></td>

                              <th>
                                {"$ "}
                                {parseFloat(granTotalFinalComisionesDos)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading == true ? <LoadingComponent /> : null}
        </>
      ) : (
        <SinPermisoComponent />
      )}
    </>
  );
};
